import { Badge, Flex, Image, Switch, Td, Text, Tr, useColorModeValue } from "@chakra-ui/react";
import React from "react";

function NoticeTableRow(props) {
    const {
        sn,
        notice,
    } = props;
    const textColor = useColorModeValue("gray.700", "white");
    const bgStatus = useColorModeValue("gray.400", "#1a202c");
    const colorStatus = useColorModeValue("white", "gray.400");

    return (
        <>
            <Tr>
                <Td>
                    <Text fontSize="md" color={textColor} fontWeight="bold">
                        {sn}
                    </Text>
                </Td>

                <Td>
                    <Text fontSize="sm" fontWeight="bold" color="gray.600" whiteSpace="normal" wordBreak="break-word">
                        {notice?.title}
                    </Text>
                </Td>

                <Td maxWidth="300px">
                    <Text fontSize="sm" color="gray.600" fontWeight="normal" whiteSpace="normal" wordBreak="break-word">
                        {notice?.description}
                    </Text>
                </Td>

                <Td>
                    <Image src={notice?.url} width={150} height={100} objectFit="cover" borderRadius="8px"/>
                </Td>

                <Td>
                    <Switch isChecked={Boolean(notice?.enabled)} />
                </Td>

                <Td>
                    <Badge
                        bg={notice?.status === "Y" ? "green.400" : notice?.status === "P" ? "yellow.400" : notice?.status === "B" ? "red.400" : "green.400"}
                        color={notice?.status === "N" ? "white" : colorStatus}
                        fontSize="16px"
                        p="3px 10px"
                        borderRadius="8px"
                    >
                        {
                            notice?.status === 'Y' ? "Active" : notice?.status === "B" ? "Blocked" : notice?.status === "P" ? "Pending" : "Active"
                        }
                    </Badge>
                </Td>
            </Tr>
        </>
    );
}

export default NoticeTableRow;